export default __webpack_public_path__ + "static/media/c2.3bf9b5ff.svg";